import { LOGOUT_URL } from "./api-url.constants";
import { API_METHODS } from "../../shared";
import { typedFetch } from "@/lib/helpers";

export const logout = async (): Promise<boolean> => {
  const result = await typedFetch(LOGOUT_URL, {
    method: API_METHODS.POST,
  });

  if (!result.ok) {
    throw new Error(`Logout failed with status ${result.status}`);
  }

  return true;
};
